/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deactivateAccount.defs.js'
export { main as default } from './deactivateAccount.defs.js'
